<template>
  <div class="order h-100">
    <app-title title="Order"/>

    <div class="row">
      <div class="col-md-3 p-md-3 text-center">
        <img class="header-logo" src="/images/logo.png">
      </div>
      <div class="col-md-7 content-middle dashboard-row p-md-3 mt-md-3">
        <router-link class="link" to="/dashboard">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-left"/>
          Dashboard
        </router-link>
      </div>
      <div class="col-md-3 sidebar sidebar-right sidebar-account p-md-3">
        <app-account/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle main">
        <app-reference/>
      </div>
      <div class="col-md-3 d-none d-sm-block sidebar sidebar-right"></div>
    </div>

    <div class="row lastrow">
      <div class="col-md-3 d-none d-sm-block p-md-3"></div>
      <div class="col-md-7 content-middle p-md-3">
        <app-order-details/>

        <app-materials/>
      </div>
      <div class="col-md-3 sidebar sidebar-right p-md-3">
        <div class="sub-title mb-1">Bestelling</div>
        <app-reference/>

        <app-deliver-date-details/>

        <app-deliver-address-details/>

        <app-overview-panels/>

        <app-confirm-order/>
      </div>
    </div>
  </div>
</template>

<script>
  // Order (middle)
  import Reference from '@/components/Order/Reference.vue'
  import OrderDetails from '@/components/Order/OrderDetails.vue'
  import Materials from '@/components/Order/Materials.vue'
  // Overview (right side)
  import Account from '@/components/Account/Account.vue'
  import DeliveryDateDetails from '@/components/Order/DeliveryDateDetails.vue'
  import DeliveryAddressDetails from '@/components/Order/DeliveryAddressDetails.vue'
  import OverviewPanels from '@/components/Order/OverviewPanels.vue'
  import ConfirmOrder from '@/components/Order/ConfirmOrder.vue'
  // Import actions & mutations
  import { FETCH_SIDES, FETCH_QUOTATION_DETAILS, ORDER_LOAD_CART_FROM_LOCAL_STORAGE } from '../store/types'

  export default {
    name: 'order',
    data() {
      return {}
    },
    components: {
      'app-account': Account,
      'app-reference': Reference,
      'app-order-details': OrderDetails,
      'app-materials': Materials,
      'app-deliver-date-details': DeliveryDateDetails,
      'app-deliver-address-details': DeliveryAddressDetails,
      'app-overview-panels': OverviewPanels,
      'app-confirm-order': ConfirmOrder
    },
    computed: {
      internalReference() {
        return this.$store.getters.internalReference
      }
    },
    created() {
      // DEBUG, load order from localstorage? We need to talk about life cycle of cart
      this.$store.dispatch(FETCH_SIDES)
      this.$store.dispatch(ORDER_LOAD_CART_FROM_LOCAL_STORAGE)
      this.$store.dispatch(FETCH_QUOTATION_DETAILS, this.internalReference)
    }
  }
</script>

<style lang="scss" scoped>
  .tool-dashboard-link {
    font-weight: bold;
  }
</style>
